var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCategory = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "42px",
    viewBox: "0 0 40 42",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "740FC1B0-50DF-4077-8D03-1C9545403382")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-New-Workflow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Builder---New-Workflow---08",
    transform: "translate(-1069.000000, -378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(297.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(0.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32-Copy-2",
    transform: "translate(598.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(15.100000, 13.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Geography",
    transform: "translate(152.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User---Index---Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Filters---01-Outlined-/-Maps-/-category",
    transform: "translate(0.900000, 0.750000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Maps-/-category"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 50 0 50 50 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,4.16666667 L13.5416667,22.9166667 L36.4583333,22.9166667 L25,4.16666667 Z M24.9999998,12.1666665 L29.020833,18.75 L20.9583332,18.75 L24.9999998,12.1666665 Z M36.4583333,27.0833333 C31.2708333,27.0833333 27.0833333,31.2708333 27.0833333,36.4583333 C27.0833333,41.6458333 31.2708333,45.8333333 36.4583333,45.8333333 C41.6458333,45.8333333 45.8333333,41.6458333 45.8333333,36.4583333 C45.8333333,31.2708333 41.6458333,27.0833333 36.4583333,27.0833333 Z M36.4583333,41.6666667 C33.5833333,41.6666667 31.25,39.3333333 31.25,36.4583333 C31.25,33.5833333 33.5833333,31.25 36.4583333,31.25 C39.3333333,31.25 41.6666667,33.5833333 41.6666667,36.4583333 C41.6666667,39.3333333 39.3333333,41.6666667 36.4583333,41.6666667 Z M6.25,44.7916667 L22.9166667,44.7916667 L22.9166667,28.125 L6.25,28.125 L6.25,44.7916667 Z M10.4166667,32.2916667 L18.75,32.2916667 L18.75,40.625 L10.4166667,40.625 L10.4166667,32.2916667 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCategory, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/category.4386ba64.svg";
export { ForwardRef as ReactComponent };